// TODO: Fix all linting warnings in layout-lib #36010
/* eslint-disable */
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { SidebarService } from './sidebar.service';

@Component({
  selector: 'ml-sidebar',
  templateUrl: './sidebar.component.html',
  standalone: false,
})
export class SidebarComponent implements OnInit, OnDestroy {
  private readonly subscriptions: Subscription[] = [];
  public showSidebar$: Observable<boolean>;

  @Input() public readonly isStatic: boolean;

  constructor(
    private readonly sidebarService: SidebarService,
    private readonly router: Router
  ) {}

  ngOnInit() {
    if (this.isStatic === true) {
      this.sidebarService.setVisibilityState(true);
    } else {
      const navEndEventSub = this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe((_event: NavigationEnd) => {
          this.sidebarService.setVisibilityState(this.isStatic);
        });

      this.subscriptions.push(navEndEventSub);
    }

    this.showSidebar$ = this.sidebarService.isVisible$;
  }

  public closeSidebarIfNotStatic(): void {
    this.sidebarService.setVisibilityState(false);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
